(() => {
  const termsSelector = 'input[name="attributes[I-Agree-To-Terms]"]';
  const timestampSelector = 'input[name="attributes[Accepted-Terms-At]"]';
  let syncingTerms = false;

  function syncTermsGate() {
    const cartForm = document.getElementById('cart');
    const terms = document.getElementById('ps-cart-terms') || document.querySelector(termsSelector);
    const checkout = document.getElementById('checkout');
    const message = document.getElementById('ps-cart-terms-error');

    if (!(cartForm instanceof HTMLFormElement) || !(terms instanceof HTMLInputElement) || !(checkout instanceof HTMLButtonElement)) {
      return;
    }

    terms.setAttribute('form', cartForm.id);
    document.querySelectorAll(timestampSelector).forEach((timestamp) => timestamp.setAttribute('form', cartForm.id));

    const updateCheckout = () => {
      const accepted = terms.checked;

      if (!syncingTerms) {
        syncingTerms = true;
        document.querySelectorAll(termsSelector).forEach((peer) => {
          if (peer !== terms && peer.checked !== accepted) {
            peer.checked = accepted;
            peer.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        syncingTerms = false;
      }

      const timestamp = document.getElementById('ps-cart-terms-timestamp');
      if (timestamp instanceof HTMLInputElement) {
        timestamp.value = accepted ? new Date().toISOString() : '';
      }

      checkout.disabled = !accepted;
      checkout.setAttribute('aria-disabled', String(!accepted));
      if (message) message.hidden = true;
    };

    if (!terms.dataset.psCartTermsBound) {
      terms.addEventListener('change', updateCheckout);
      terms.dataset.psCartTermsBound = 'true';
    }

    if (!cartForm.dataset.psCartTermsBound) {
      cartForm.addEventListener('submit', (event) => {
        const submitter = event.submitter;
        const isCheckout = submitter === checkout || submitter?.getAttribute('name') === 'checkout';

        if (isCheckout && !terms.checked) {
          event.preventDefault();
          if (message) message.hidden = false;
          terms.focus();
        }
      });
      cartForm.dataset.psCartTermsBound = 'true';
    }

    updateCheckout();
  }

  const observer = new MutationObserver(syncTermsGate);

  document.addEventListener('DOMContentLoaded', () => {
    syncTermsGate();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
